import React from 'react';
import { LanguagesEnum } from '../../../../config/languages';
import ActionBlock from './components/datatable/actions';
import * as DatesUtils from '../../../../utils/dates';
const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  header: {
    [LanguagesEnum.English]: 'Fixed Establishments',
    [LanguagesEnum.Greek]: 'Σταθερές εγκαταστάσεις',
  },
  subtitle: {
    [LanguagesEnum.English]:
      'In case the supply of goods or services happens from a Member State other than Cyprus please fill in the below list:',
    [LanguagesEnum.Greek]:
      'In case the supply of goods or services happens from a Member State other than Cyprus please fill in the below list:',
  },
  issuing_country_label: {
    [LanguagesEnum.English]: 'Issuing Country',
    [LanguagesEnum.Greek]: 'Χώρα Έκδοσης',
  },
  type_label: {
    [LanguagesEnum.English]: 'Type',
    [LanguagesEnum.Greek]: 'Τύπος',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'Identifier',
    [LanguagesEnum.Greek]: 'Αριθμός ΦΠΑ',
  },
  company_name_label: {
    [LanguagesEnum.English]: 'Company Name',
    [LanguagesEnum.Greek]: 'Όνομα εταιρείας',
  },
  address_street_label: {
    [LanguagesEnum.English]: 'Address Street',
    [LanguagesEnum.Greek]: 'Οδός',
  },
  number_label: {
    [LanguagesEnum.English]: 'Number',
    [LanguagesEnum.Greek]: 'Αριθμός',
  },
  postal_code_label: {
    [LanguagesEnum.English]: 'Post Code',
    [LanguagesEnum.Greek]: 'Ταχυδρομικός Κώδικας',
  },
  city_label: {
    [LanguagesEnum.English]: 'City',
    [LanguagesEnum.Greek]: 'Πόλη',
  },
  country_label: {
    [LanguagesEnum.English]: 'Country',
    [LanguagesEnum.Greek]: 'Χώρα',
  },
  date_of_first_supply_label: {
    [LanguagesEnum.English]: 'Date Of First Supply',
    [LanguagesEnum.Greek]: 'Date Of First Supply',
  },
  modal_header: {
    [LanguagesEnum.English]: 'Add Fixed Establishment',
    [LanguagesEnum.Greek]: 'Add Fixed Establishment',
  },
  add: {
    [LanguagesEnum.English]: 'Add',
    [LanguagesEnum.Greek]: 'Προσθήκη',
  },
  fixedEstablishmentDeclarationValue1: {
    [LanguagesEnum.English]:
      'I have a fixed establishment in that Member State.',
    [LanguagesEnum.Greek]: 'I have a fixed establishment in that Member State.',
  },
  fixedEstablishmentDeclarationValue2: {
    [LanguagesEnum.English]:
      'I own a place of dispatch or transport of goods or I do not own a place of dispatch or transport of goods but I have a Vat Identification Number as non-established.',
    [LanguagesEnum.Greek]:
      'I own a place of dispatch or transport of goods or I do not own a place of dispatch or transport of goods but I have a Vat Identification Number as non-established.',
  },
};

export const TableColumns = (mode: 'VIEW' | 'EDIT') => {
  return [
    {
      label: '#',
      id: 'fixed_establish_id',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Country',
      id: 'issuing_country_name',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Taxation Type',
      id: 'type',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Identification Number',
      id: 'vat_id_num',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Address Street',
      id: 'street',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Address Number',
      id: 'building_identifier',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Address Country',
      id: 'addess_country',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Post Code',
      id: 'post_code',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'City',
      id: 'city',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Date of First Supply',
      id: 'start_date',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>
          {DatesUtils.formatDateTimeSeconds(cellValue)}
        </React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Actions',
      align: 'center',
      id: 'action',
      render: (
        rowIndex: number,
        cellValue: any,
        columnIndex: number,
        data: any
      ) => <ActionBlock rowIndex={rowIndex} mode={mode} />,
      inData: false,
    },
  ];
};

export default CONFIGURATION;
